'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
module.exports = exports['default'];
//# sourceMappingURL=gif.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ally.js/supports/media/gif.js
// module id = 6
// module chunks = 0